import styles from './styles.module.scss'
import Image from 'next/image'
import { useState, useEffect } from 'react'
import { RatingTierModal } from 'src/pages/ListDetails/components/ContentInfo/components/RatingTierModal'

export const ReviewRatings = ({ ratingData }) => {
  const [visibleRatingTier, setVisibleRatingTier] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const score = ratingData?.attributes?.score

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleMouseEnter = () => {
    if (!isMobile) {
      setVisibleRatingTier(true)
    }
  }

  const handleMouseLeave = () => {
    if (!isMobile) {
      setVisibleRatingTier(false)
    }
  }

  const handleClickModal = () => {
    if (isMobile) {
      setVisibleRatingTier(true)
    }
  }

  const handleCloseModal = event => {
    event.stopPropagation()
    setVisibleRatingTier(false)
  }

  let ratingColor = ''
  if (score >= 1 && score <= 3.9) {
    ratingColor = '#EA5C5C'
  } else if (score >= 4 && score <= 6.9) {
    ratingColor = '#F38181'
  } else if (score >= 7 && score <= 9.9) {
    ratingColor = '#7CC07C'
  } else {
    ratingColor = '#52AD53'
  }

  let starImagePath = '/assets/icons/icon-star-rating-darkred.svg' // Default color
  if (score >= 4 && score <= 6.9) {
    starImagePath = '/assets/icons/icon-star-rating-red.svg'
  } else if (score >= 7 && score <= 9.9) {
    starImagePath = '/assets/icons/icon-star-green.svg'
  } else if (score >= 10) {
    starImagePath = '/assets/icons/icon-star-rating-darkgreen.svg'
  }
  return (
    <div>
      <div className={styles.gridItem}>
        <div className={styles.ratingContainer}>
          <div className={styles.ratingSection}>
            <p className={styles.ratingNumber} style={{ color: ratingColor }}>
              {score}{' '}
            </p>
            <div className={styles.starImage}>
              <Image
                src={starImagePath}
                height={15}
                width={15}
                alt='colored-star'
              />
            </div>
          </div>

          <p className={styles.ratingName}>
            {ratingData.attributes.ratingAttribute.data.attributes.name}
          </p>
        </div>
        <div className={styles.gridImage}>
          <Image
            src='/assets/icons/icon-info.svg'
            alt='Information'
            width={24}
            height={24}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClickModal}
          />
        </div>
        {visibleRatingTier && (
          <RatingTierModal
            attributes={ratingData?.attributes.ratingAttribute.data.attributes}
            closeModal={handleCloseModal}
            modalStyle='modalBelow'
          />
        )}
      </div>
    </div>
  )
}
